export const MODULE_NAME = 'thirdpartyIntegrations';
export const BASE_API = 'integrations';
//integrations by vendorId
export const SET_INTEGRATIONS = 'setIntegrations';
export const INTEGRATIONS = 'integrations';

//integration by vendorId
export const SET_INTEGRATION = 'setIntegration';
export const INTEGRATION = 'integration';

export const SAVE_INTEGRATION = 'saveIntegration';

//APIs
export const APIS = 'apis';
export const SET_INTEGRATIONS_APIS = 'setIntegrationsAPIs';

import {
	ERROR as error,
	SET_ERROR as setError
} from '@/sections/error-mutation-types';

export const ERROR = error;
export const SET_ERROR = setError;

import {
	LOADING as loading,
	SET_LOADING as setLoading
} from '@/sections/loading-mutation-types';

export const LOADING = loading;
export const SET_LOADING = setLoading;

import { TOAST_MESSAGES_PUSH as toastMessagesPush } from '@/sections/toast-mutation-types';

export const TOAST_MESSAGES_PUSH = toastMessagesPush;
